export default {
  API:process.env.VUE_APP_ENDPOINT,
  SHORT_DATE_FORMAT: "DD-MM-YYYY",
  DATE_FORMAT: "DD/MM/YYYY HH:mm:ss",
  SQL_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  PAGINATION: {
    page: 1,
    itemsPerPage: 20,
    mustSort: true,
    sortDesc: [1],
    sortBy: ["ID"]
  },
  ITEMS_PER_PAGE:{
    'items-per-page-options': [20, 30, 40, 50]
  },
  COLOR_CHART: {
    blue: '#4C84FF',
    blue_light: '#A9C4FF',
    red: '#2670b0',
    red_light: '#FE9FA5'
  },
  COMPARE_PERIOD: [
    'Previous period',
    'Previous month',
    'Previous year'
  ],
  VIP_LEVEL: [
    { value: 1, name: '', color: '' },
    { value: 2, name: 'v1', color: '#FFCC80' },
    { value: 3, name: 'v2', color: '#FFB74D' },
    { value: 4, name: 'v3', color: '#FFA726' },
    { value: 5, name: 'v4', color: '#FB8C00' },
    { value: 6, name: 'v5', color: '#F57C00' },
    { value: 7, name: 'v6', color: '#EF6C00' },
  ],
  PACKAGE_STATUS_ENUM: {
    NHAP_KHO_TQ: 0,
    DANG_THONG_QUAN: 1,
    NHAP_KHO_VN: 2
  },
  PACKAGE_STATUS: [
    { value: 0, name: 'Nhập kho TQ', disabled: false, color: '#FFB74D', textColor: '#FFF' },
    { value: 1, name: 'Đang thông quan', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 2, name: 'Nhập kho VN', disabled: false, color: 'black', textColor: '#FFF' },
  ],
  LOCATION_STORE: [
    { value: 1, name: 'Kho Hà Nội', shortname: 'HN' },
    { value: 2, name: 'Kho Thái Nguyên', shortname: 'TN' },
    { value: 3, name: 'Kho Hồ Chí Minh', shortname: 'HCM' },
  ],
  CUSTOMER_STATUS: {
    InActive: 1,
    Actived: 2,
    Blocked: 3
  },
  CUSTOMER_STATUS_LIST: [
    { value: 1, name: 'Đã kích hoạt', color: '#0059b3' },
    { value: 2, name: 'Đang bị khóa', color: '#e63900' },
  ],
  DATA_TYPE: {
    String: 0,
    Number: 1,
    Enum: 2,
    Date: 3
  },
  LIST_COMPARISON: [
    { name: 'Có chứa', value: 'contain', display: '({0})', dataType: 0 },
    { name: 'Không chứa', value: 'does_not_contain', display: '-({0})', dataType: 0 },
    { name: 'Bằng', value: 's_equal', display: '= {0}', dataType: 0 },
    { name: 'Khác', value: 's_does_not_equal', display: '!= {0}', dataType: 0 },
    { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 1 },
    { name: 'Khác', value: 'does_not_equal', display: '!= {0}', dataType: 1 },
    { name: 'Lớn hơn', value: 'greater_than', display: '> {0}', dataType: 1 },
    { name: 'Lớn hơn hoặc bằng', value: 'greater_than_or_equal', display: '>= {0}', dataType: 1 },
    { name: 'Nhỏ hơn', value: 'less_than', display: '< {0}', dataType: 1 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'less_than_or_equal', display: '<= {0}', dataType: 1 },
    { name: 'Bằng', value: 'in', display: '= [{0}]', dataType: 2 },
    { name: 'Khác', value: 'not_in', display: '!= [{0}]', dataType: 2 },
    { name: 'Bằng', value: 'd_equal', display: '= {0}', dataType: 3 },
    { name: 'Khác', value: 'd_does_not_equal', display: '!= {0}', dataType: 3 },
    { name: 'Lớn hơn', value: 'd_greater_than', display: '> {0}', dataType: 3 },
    { name: 'Lớn hơn hoặc bằng', value: 'd_greater_than_or_equal', display: '>= {0}', dataType: 3 },
    { name: 'Nhỏ hơn', value: 'd_less_than', display: '< {0}', dataType: 3 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'd_less_than_or_equal', display: '<= {0}', dataType: 3 },
  ],
  ROLE_TYPE: {
    User: 0,
    Admin: 1,
    Staff: 2
  },
  ROLES: [
    { value: 0, name: 'User'},
    { value: 1, name: 'Admin'},
    { value: 2, name: 'Staff'}
  ],
  TRADE_TYPE: [
    { value: 1, name: 'Đặt cọc'},
    { value: 2, name: 'Nhận lại tiền đặt cọc' },
    { value: 3, name: 'Thanh toán hóa đơn' },
    { value: 4, name: 'Nạp tiền' },
    { value: 5, name: 'Rút tiền' },
    { value: 6, name: 'Hủy lệnh rút tiền' },
    { value: 7, name: 'Xử lý khiếu nại' },
    { value: 8, name: 'Hủy lệnh chuyển tiền' },
  ],
  FEE_TYPE: {
    ByWeight: 0,
    ByVolume: 1
  },
  FEE_TYPES: [
    { value: 0, name: 'Theo cân'},
    { value: 1, name: 'Theo khối' }
  ],
  BIGPACKAGE_STATUS_TYPE: {
    NHAP_KHO_TQ: 0,
    DANG_THONG_QUAN: 1,
    NHAP_KHO_VN: 2
  },
  BIGPACKAGE_STATUS: [
    { value: 0, name: 'Nhập kho TQ', disabled: false, color: '#FFB74D', textColor: '#FFF' },
    { value: 1, name: 'Đang thông quan', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 2, name: 'Nhập kho VN', disabled: false, color: 'black', textColor: '#FFF' },
  ],
  PRODUCT_TYPE_ENUM: {
    All: -1,
    HangLe: 0,
    HangKien: 1,
    HangCongKenh: 2,
  },
  PRODUCT_TYPE: [
    { value: -1, name: 'Tất cả', color: '#000000'},
    { value: 0, name: 'Hàng lẻ', color: '#0059b3'},
    { value: 1, name: 'Hàng kiện', color: '#FB8C00'},
    { value: 2, name: 'Hàng cồng kềnh', color: '#e63900'},
  ],
  SHIPPING_METHOD_ENUM: {
    TMDT: 0,
    Duong_Khong: 1,
    Duong_Bo: 2,
    Duong_Bien: 3
  },
  SHIPPING_METHOD: [    
    { value: 0, name: 'TMĐT', color: '#0E9E13'},
    { value: 1, name: 'Đường bay', color: '#FB8C00'},
    { value: 2, name: 'Đường bộ Đông Hưng', color: '#e63900'},
    { value: 3, name: 'Đường biển', color: '#0059b3'},
    { value: 4, name: 'Đường bộ Quảng Châu', color: '#0059b3'}
  ]
};